import { apiCall } from "../../../services/api-service.js";

const get = (endpoint, params) => apiCall("get", endpoint, null, { params });
const post = (endpoint, body) => apiCall("post", endpoint, body);
const put = (endpoint, body) => apiCall("put", endpoint, body);
const del = (endpoint, data = null) => apiCall("delete", endpoint, data);

export const getVendorStageListApi = async (params) => {
  try {
    return await get("vendor_stage", params);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};


export const submitVendorStageApi = async (body) => {
  try {
    return await post("vendor_stage", body);
  } catch (err) {
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};


export const updateVendorStageListApi = async (id, body) => {
  try {
    return await put(`vendor_stage/${id}`, body);
  } catch (err) {
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const bulkDeleteVendorStageApi = async (payload) => {
  try {
    const data = Array.isArray(payload) ? { id: payload } : payload;
    return await del("vendor_stage/bulk_delete", data);
  } catch (err) {
    console.error("Error fetching category:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const deleteVendorStageListApi = async (id) => {
  try {
    return await del(`vendor_stage/delete/${id}`);
  } catch (err) {
    console.error("Error fetching category:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
export const getVendorStageByIdApi = async (id) => {
  try {
    return await get(`vendor_stage/edit/${id}`);
  } catch (err) {
    console.error("Error fetching category:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};